import { jsx as _jsx } from "react/jsx-runtime";
import Loading from '../Loading/Loading';
const PageLoading = ({ delay = 2000, secondary = false }) => {
    return (_jsx("div", { children: _jsx(Loading, { delay: delay, secondary: secondary }) }));
};
export default PageLoading;
